import './viz.css'

interface SparklineProps {
  values: number[]
  color?: string
  height?: number
  ariaLabel: string
}

/** Tiny trend line with a 12%-opacity area fill. Stretches to its container width. */
export function Sparkline({ values, color = 'var(--series-1)', height = 28, ariaLabel }: SparklineProps) {
  if (values.length < 2) return null

  const n = values.length
  const min = Math.min(...values)
  const max = Math.max(...values)
  const span = max - min || 1

  const points = values.map((v, i) => {
    const x = (i / (n - 1)) * 100
    const y = 2 + (1 - (v - min) / span) * (height - 4)
    return `${x},${y}`
  })

  const line = `M${points.join(' L')}`
  const area = `${line} L100,${height} L0,${height} Z`

  return (
    <svg
      className="viz-spark"
      role="img"
      aria-label={ariaLabel}
      viewBox={`0 0 100 ${height}`}
      preserveAspectRatio="none"
      height={height}
      style={{ color }}
    >
      <path className="viz-spark-area" d={area} />
      <path className="viz-spark-line" d={line} />
    </svg>
  )
}
